import { ArrowUpRight } from "lucide-react";
import { AWARDS } from "@/lib/site";
import quadrupleFinalist from "@/assets/awards/quadruple-finalist.png.asset.json";
import finalist from "@/assets/awards/finalist.png.asset.json";

export function AwardFooter() {
  return (
    <a href={AWARDS.url} target="_blank" rel="noopener noreferrer" className="mt-6 flex items-center gap-4 text-left text-primary-foreground hover:underline underline-offset-4">
      <img src={finalist.url} alt="UK Small Business Awards 2026 finalist badge" width={96} height={96} loading="lazy" decoding="async" className="h-24 w-24 shrink-0 object-contain" />
      <span className="text-base leading-snug"><span className="block font-semibold">2026 awards finalist</span><span className="block">{AWARDS.name}</span></span>
    </a>
  );
}

export default function AwardRecognition() {
  return (
    <section aria-labelledby="awards-heading" className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-6">
        <div className="grid items-center gap-8 border-y border-border py-10 md:grid-cols-[220px_1fr] md:gap-12">
          <a href={AWARDS.url} target="_blank" rel="noopener noreferrer" className="mx-auto block w-44 md:w-full" aria-label="Visit the UK Small Business Awards website">
            <img src={quadrupleFinalist.url} alt="Four-time finalist at the Official UK Small Business Awards 2026" width={220} height={220} loading="lazy" decoding="async" className="aspect-square w-full object-contain" />
          </a>
          <div>
            <p className="mb-3 font-semibold text-primary max-md:text-center">UK Small Business Awards 2026</p>
            <h2 id="awards-heading" className="text-4xl font-bold text-foreground">{AWARDS.heading}</h2>
            <p className="mt-4 text-base text-foreground">{AWARDS.description}</p>
            <dl className="mt-6 grid grid-cols-2 gap-5 lg:grid-cols-4">
              {AWARDS.categories.map((category) => (
                <div key={category.name} className="border-l-2 border-primary pl-4">
                  <dt className="font-semibold text-foreground">{category.name}</dt>
                  <dd className="mt-1 text-foreground">{category.entrant} · 2026 finalist</dd>
                </div>
              ))}
            </dl>
            <div className="mt-6 max-md:text-center"><a href={AWARDS.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold text-primary underline underline-offset-4">About the awards <ArrowUpRight className="h-4 w-4" aria-hidden="true" /></a></div>
          </div>
        </div>
      </div>
    </section>
  );
}